import { render, staticRenderFns } from "./Airports.vue?vue&type=template&id=2a6f4db2"
import script from "./Airports.vue?vue&type=script&lang=js"
export * from "./Airports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports